import {
    NinchatActionType,
    NinchatUpdateMessageAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const updateMessage = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatUpdateMessageAction}`,
    async (arg: NinchatActionParams<NinchatUpdateMessageAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatUpdateMessageAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
